import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import "@/App.css";
import { api } from "./api";
import { Login, Layout } from "./components/Shell";
import { Dashboard, FacilitySearch, ProcedureSearch, Profile, UploadBridge } from "./components/OperatorPages";
import { Admin } from "./components/AdminPage";
import { AndroidUpdatesAdmin } from "./components/AndroidUpdatesAdmin";
import { AlgorithmsPage } from "./components/AlgorithmsPage";
import { ActivateAccount } from "./components/ActivateAccount";
import { ForgotPassword, ResetPassword } from "./components/PasswordRecovery";
import { AndroidEmailDownload } from "./components/AndroidEmailDownload";
import { SystemReleases } from "./components/SystemReleases";
import { SystemReleasesAdmin } from "./components/SystemReleasesAdmin";

function AppInner() {
  const [user, setUser] = useState(null);
  const [sessionMessage, setSessionMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const can = permission =>
  user?.permissions?.includes(permission);

  useEffect(() => {
    const sessionExpired = () => {
      setSessionMessage(
        "Sessione scaduta o revocata. Effettua nuovamente l'accesso."
      );
      setUser(null);
      if (!["/attiva-account", "/password-dimenticata", "/reset-password", "/download-android"].includes(location.pathname)) {
        navigate("/");
      }
    };

    window.addEventListener("auth:session-expired", sessionExpired);

    if (!["/attiva-account", "/password-dimenticata", "/reset-password", "/download-android"].includes(location.pathname) && localStorage.getItem("token")) {
      api.get("/auth/me")
        .then(r => setUser(r.data))
        .catch(() => {
          localStorage.removeItem("token");
          setUser(null);
        });
    }

    return () => {
      window.removeEventListener("auth:session-expired", sessionExpired);
    };
  }, [navigate, location.pathname]);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(null);
    navigate("/");
  };
  if (location.pathname === "/attiva-account") {
    return <ActivateAccount />;
  }

  if (location.pathname === "/password-dimenticata") {
    return <ForgotPassword />;
  }

  if (location.pathname === "/reset-password") {
    return <ResetPassword />;
  }

  if (location.pathname === "/download-android") {
    return <AndroidEmailDownload />;
  }

  if (!user) {
    return (
      <Login
        message={sessionMessage}
        onLogin={loggedUser => {
          setSessionMessage("");
          setUser(loggedUser);
        }}
      />
    );
  }
  return <Layout user={user} onLogout={logout}>
    <Routes>
      <Route path="/" element={<Dashboard user={user}/>}/>
      <Route path="/novita" element={<SystemReleases/>}/>
      {user?.role === "admin" && (
        <Route path="/admin/rilasci" element={<SystemReleasesAdmin user={user}/>} />
      )}
      {can("operative.facilities.read") &&
  <Route path="/strutture" element={<FacilitySearch/>}/>
}

      {can("operative.ai.use") &&
  <Route path="/procedure" element={<ProcedureSearch/>}/>
}

      {can("operative.algorithms.read") &&
  <Route path="/algoritmi" element={<AlgorithmsPage/>}/>
}

      <Route path="/profilo" element={<Profile user={user} onUserChange={setUser}/>}/>
      {can("admin.android_updates.read") &&
        <Route path="/admin/android-updates" element={<AndroidUpdatesAdmin user={user}/>} />
      }
      {can("admin.dashboard.read") &&
  <Route path="/admin" element={<Admin user={user}/>}/>
}

{can("admin.facilities.read") &&
  <Route
    path="/admin/strutture"
    element={<Admin user={user} section="facilities"/>}
  />
}

{can("admin.services.read") &&
  <Route
    path="/admin/servizi"
    element={<Admin user={user} section="services"/>}
  />
}

{can("admin.algorithms.read") &&
  <Route
    path="/admin/algoritmi"
    element={<Admin user={user} section="algorithms"/>}
  />
}

{can("admin.documents.read") &&
  <Route
    path="/admin/documenti"
    element={<Admin user={user} section="documents"/>}
  />
}

{can("admin.users.read") &&
  <Route
    path="/admin/utenti"
    element={<Admin user={user} section="users"/>}
  />
}

{can("admin.roles.read") &&
  <Route
    path="/admin/ruoli"
    element={<Admin user={user} section="roles"/>}
  />
}

{can("admin.audit.read") &&
  <Route
    path="/admin/audit"
    element={<Admin user={user} section="audit"/>}
  />
}

    </Routes>
  </Layout>;
}

export default function App() {
  return <BrowserRouter>
    <UploadBridge/>
    <AppInner/>
  </BrowserRouter>;
}
